var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Table', {
    attrs: {
      "items": _vm.eventsList,
      "columns": _vm.columns,
      "actions": _vm.actions,
      "filterProp": "event_action",
      "loading": _vm.loading.events
    }
  }), _c('Dialog', {
    attrs: {
      "title": _vm.dialogTitle,
      "show": _vm.showDialog,
      "onClose": _vm.onCloseDialog
    }
  }, [_vm._v(" You can copy a param by simply clicking it. "), _c('div', {
    staticClass: "list"
  }, _vm._l(_vm.latestEventsList, function (event, index) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: _vm.loading.latestEvents,
        expression: "loading.latestEvents"
      }],
      key: event.id
    }, [_c('h4', [_vm._v("Reported at: " + _vm._s(event.date))]), _c('ul', _vm._l(event.params, function (param) {
      return _c('li', {
        key: param.key
      }, [_c('a', {
        on: {
          "click": function ($event) {
            return _vm.onCopy(param.key);
          }
        }
      }, [_c('b', [_vm._v(_vm._s(param.key))])]), _vm._v(": " + _vm._s(param.value) + " ")]);
    }), 0), index < _vm.latestEvents.length - 1 ? _c('el-divider') : _vm._e()], 1);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }